import styled from 'styled-components';
import {List, Button} from 'global/styles/styles.js';
const S = {};

const duration = 300;

S.BetHistoryItemDetails = styled.div`
  &.slide-transition-enter {
      max-height: 0px;
      margin-bottom: 3.75rem;
      overflow: hidden;
      transition: max-height ${duration}ms;
  }
  
  &.slide-transition-enter-active {
       max-height: 10000px;
  }
  
  &.slide-transition-exit-active {
       max-height: 0;
  }
  
`;

S.BetHistoryDetailsWrapper = styled.div`
    width: 100%;
`;

S.BetHistoryDetailsHeader = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    border-collapse: collapse;
    color: #000;
`;

S.BetHistoryDetailsHeaderInfoIcon = styled.div`
    display: flex;
    flex: 1 1 0;
    justify-content: flex-end;

    & .tvBet {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30%;
        height: 20px;
        font-size: .7rem;
        border-radius: 4px;   
        color: ${({theme:{$accountProfileBetHistoryTvBetIconColor}})=> $accountProfileBetHistoryTvBetIconColor};
        border: 1px solid ${({theme:{$accountProfileBetHistoryTvBetBorderColor}})=> $accountProfileBetHistoryTvBetBorderColor}; 
    }
`

S.BetHistoryDetailsHeaderActions = styled.div`
    display: flex;
    align-items: center;
    height: 52px;
    padding: 0 1.4375rem;
    background-color: ${({theme:{$accountProfileBetHistoryTransactionDetailsHeaderBgActions}})=> $accountProfileBetHistoryTransactionDetailsHeaderBgActions};
`;

S.BetHistoryDetailsHeaderGoBack = styled.div`
    display: flex;
    width: 24px;
    height: 24px;
    margin-right: 1.33rem;
    background: url(/images/svg/ic_expand_close.svg) no-repeat;
    background-size: contain;
`;

S.BetHistoryDetailsHeaderTitle = styled.div`
    display: flex;
    padding-bottom: 2px;
    font-size: 1.38rem;
    font-weight: 600;
    color: ${({theme:{$accountProfileBetHistoryTransactionDetailsHeaderTitle}})=> $accountProfileBetHistoryTransactionDetailsHeaderTitle};
`;

S.BetHistoryDetailsHeaderShareActions = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 150px;
    margin-left: auto;

    & .shareIcon {
        display: flex;
        width: 32px;
        height: 32px;
        margin-right: 0.67rem;
        background-size: contain;
    }
`;

S.BetHistoryDetailsHeaderRebet = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    height: 1.88rem;
    margin-left: auto;
    padding: 0 0.88rem;
    line-height: 1;
    font-size: 0.88rem;
    font-weight: 600;
    border-radius: 3px;
    background-color: ${({theme:{$accountProfileBetHistoryTransactionDetailsRebetBackground}})=> $accountProfileBetHistoryTransactionDetailsRebetBackground};
    cursor: pointer;
`;

S.BetHistoryDetailsHeaderShareFb = styled.div`
    background: url(/images/svg/fb.svg) no-repeat;
`;

S.BetHistoryDetailsHeaderShareTwitter = styled.div`
    background: url(/images/svg/twitterShare.svg) no-repeat;
`;

S.BetHistoryDetailsHeaderShareLink = styled.div`
    background: url(/images/svg/share.svg) no-repeat;
    &:last-child {
        margin-right: 0;
    }
`;

S.InfoContainer = styled.div`
    display: ${({inView})=>(inView == true ? 'flex': 'none')};
    justify-content: space-between;
    align-items: center;
    height: 2.5rem;
    padding-left: 1.67rem;
    font-size: 0.88rem;
    background-color: ${({theme:{$accountProfileBetHistoryShareLinkInfoSuccessBackground}})=> $accountProfileBetHistoryShareLinkInfoSuccessBackground};
    color: ${({theme:{$accountProfileBetHistoryShareLinkInfoSuccessColor}})=> $accountProfileBetHistoryShareLinkInfoSuccessColor};

    & .close {
        display: flex;
        width: 1.5rem;
        height: 1.5rem;
        margin-right: 1.67rem;
        background: url(/images/svg/ic_expand_close.svg) no-repeat;
        background-size: contain;
    }
`;

S.BetHistoryDetailsHeaderInfo = styled.div`
    display: flex;
    align-items: center;
    height: 46px;
    padding: 0 1.4375rem;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1; 
    color: ${({theme:{$accountProfileBetHistoryTransactionDetailsMainColor}})=> $accountProfileBetHistoryTransactionDetailsMainColor};
    background-color: ${({theme:{$accountProfileBetHistoryTransactionDetailsHeaderBgInfo}})=> $accountProfileBetHistoryTransactionDetailsHeaderBgInfo};

    &:last-child {
        border-top: 1px solid ${({theme:{$accountProfileBetHistoryTvBetInfoSecionSeparator}})=> $accountProfileBetHistoryTvBetInfoSecionSeparator};
    }

    & .tvBet {
        line-height: 1.4;
    }
`;

S.betHistoryBlockHeader = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0.83rem 0;
    padding: 0 1.4375rem;
    height: 24px;
    font-weight: 600; 
    background-color: ${({theme:{$accountProfileBetHistoryTransactionDetailsHeaderBlockBg}})=> $accountProfileBetHistoryTransactionDetailsHeaderBlockBg};
    color: ${({theme:{$accountProfileBetHistoryTransactionDetailsHeaderBlockTxt}})=> $accountProfileBetHistoryTransactionDetailsHeaderBlockTxt};
`;

S.BetHistoryDetailsHeaderInfoSliptype = styled.div`
    font-weight: 600;
`;

S.BetHistoryDetailsHeaderInfoDate = styled.div`
    margin-left: 2.67rem;
`;

S.BetHistoryDetailsHeaderInfoId = styled.div`
    margin-left: auto;
`;

S.BetHistoryDetailsBody = styled.div`
    width: 100%;
    color: ${({theme:{$accountProfileBetHistoryTransactionDetailsMainColor}})=> $accountProfileBetHistoryTransactionDetailsMainColor};
    display: flex;
    flex-direction: column;
`;

S.BetHistoryDetailsBodyInfo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    height: 26px;
    margin-bottom: 0.75rem;
    margin: 0.13rem 1.4375rem 0.88rem;
    padding: 0.25rem 0;
    border-bottom: 2px solid ${({theme:{$accountProfileBetHistoryTransactionHeaderBorder}})=> $accountProfileBetHistoryTransactionHeaderBorder};

    & .details-time {
        display: flex;
        align-items: center;

        & span {
        font-size: 0.69rem;
        font-weight: 600;
        color: ${({theme:{$accountProfileBetHistoryTransactionDetailsMainColor}})=> $accountProfileBetHistoryTransactionDetailsMainColor};
        }
    }

    & .details-time {
        padding-bottom: 2px;
    }

    & .details-category {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 1;
        font-size: 0.69rem;
        max-width: 100%;

        & span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        & .separator {
            display: block;
            margin: 0 0.42rem;
            width: 0.5rem;
            height: 0.5rem;
            background-image: url(/images/svg/arrow-right-separator.svg);
            background-repeat: no-repeat;
        }
    }
`;

S.BetHistoryDetailsBodyTransactionData = styled.div`
    display: flex;
    margin: 0 1.4375rem;
    padding-bottom: 0.44rem;
    background-color: ${({theme:{$accountProfileBetHistoryTransactionDetailsBg}})=> $accountProfileBetHistoryTransactionDetailsBg};
    border-radius: 0.25rem;
`;

S.BetHistoryDetailsBodyTransactionDataIcon = styled.div`
    display: flex;
    justify-content: center;
    padding-top: 0.69rem;
    width: 14%;

    & > div {
        font-size: 1.25rem;
    }
`;

S.BetHistoryDetailsBodyTransactionDataTypes = styled.div`
    display: flex;
    justify-content: flex-start;
    width: 75%;

    & .details-bet {
        display: flex;
        flex-direction: column;
        font-weight: 400;
        
        &.status-4 > span {
            text-decoration: line-through;
            text-decoration-color: #C62828;
        }

        & .event-name  {
            padding: 0.38rem 0 0.25rem 0;
            font-size: 0.88rem;
            font-weight: 600;
        }
        & .game-name  {
            padding-bottom: 0.5rem;
            font-size: 0.69rem;
            line-height: 1;
        }
        & .outcome-name {
            font-size: 0.81rem;
        }
    }
`;

S.BetHistoryDetailsBodyTransactionDataResults = styled.div`
    display: flex;
    flex-direction: column;
    width: 25%;

    & > div {
        display: flex;
        justify-content: space-between;
        padding-right: 1rem;

        &.details-result {
            padding: 0.38rem 1rem 2.25rem 0;
            font-size: 0.88rem;
            font-weight: 600;
            justify-content: flex-end;
            & .details-score {
                text-align: right;
            }
        }
    }
    & .details-odds {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.81rem;
        &.status-4 {
            text-decoration: line-through;
            text-decoration-color: #C62828;
        }
    }
    & .cashback.item-icon {
        margin: 0 0 0 .7rem;
    }
`;

S.StatusIcon = styled.div`
    &.details_lost,
    &.details_won,
    &.details_placed,
    &.details_cancel,
    &.details_cashouted {
        height: 1rem;
        width: 1rem;
        border-radius: 20px;
        background: none;
        background-size: contain;
        background-repeat: no-repeat;
    }
    &.details_lost {
        background-image: url(/images/svg/lost-24px.svg);
    }
    &.details_won {
        background-image: url(/images/svg/win-24px.svg);
    }
    &.details_placed {
        background-image: url(/images/svg/placed-24px.svg);
        width: 0.9rem;
    }
    &.details_cashouted {
        background-image: url(/images/svg/cashout-24px.svg);
    }
    &.details_cancel {
        background-image: url(/images/svg/cancel-24px.svg);
    }
    &.cashbackIcon {
        width: 18px;
        height: 18px;
        background-image: url(/images/svg/cashback_icon_small.svg);
        margin-left: 0;
        margin-right: .7rem;
    }
    &.earlyPayout {
        width: 18px;
        height: 18px;
        background-image: url(/images/svg/earlyPayout.svg);
        margin-right: .7rem;
    }
`;

S.BetHistoryItemsFooter = styled.div`
    display: flex;
    padding: 1.25rem 23px;
    font-size: 0.94rem;
    color: ${({theme:{$accountProfileBetHistoryTransactionDetailsFooterTxt}})=> $accountProfileBetHistoryTransactionDetailsFooterTxt};
`;

S.BetHistoryItemsFooterLabels = styled.div`
    display: flex;
    flex-direction: column;
    flex-basis: 50%;
    font-weight: 400;

    & > div {
        padding-bottom: 0.43rem;
    }
    & .ako {

    }
    & .stake {
        font-weight: 600;
    }
    & .possibleWin,
      .confirmedWin,
      .cashback {
        font-size: 0.81rem;
        font-weight: 700;
    }
    & .cashback {
        display: flex;
        & .cashBackLabel {
            display: flex;
            align-items: center;
        }
    }
	& .tax0nWinning,
    & .taxFactor {
        font-size: 0.69rem;
    }
`;

S.BetHistoryItemsFooterInfo = styled(S.BetHistoryItemsFooterLabels)`
    align-items: flex-end;
    & .confirmedWin {
        &.won {
            color: ${({theme:{$accountProfileBetHistoryTransactionWonLabelColor}})=> $accountProfileBetHistoryTransactionWonLabelColor};
        }
    }
`;

S.BonusField = styled.div`
    color: red;
`;

export default S;